module.exports = __webpack_public_path__ + "static/media/snugglefish.c27aa1bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/snugglefish.png
// module id = 2561
// module chunks = 0